import React from "react"
import LocalLang from '../Utility/Method/LocalLang'
import LocalToken from '../Utility/Method/LocalToken'
import { DefaultLang } from '../Utility/DefaultLang'
import LocalConfig from "../Utility/Method/LocalConfig"
const localConfigs = LocalConfig.Get()
const LocalContext = React.createContext({
    lang: LocalLang.Get() || DefaultLang,
    setLang: () => { },
    hasToken: LocalToken.Get('tokenObj') ? true : false,
    setHasToken: () => { },
    config: localConfigs ? localConfigs : null,
    setConfig: () => { },
    // role: localConfigs ? localConfigs.role : null,
    // setRole: () => { },
    AppConfig: {},
    setAppConfig: () => { }
})
export default LocalContext